import { useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import logo from '../../../assets/logo_red.png';
import { useTranslation } from '../../../services/LanguageContext';
import './footer.scss';

const Footer = () => {
    const { lang } = useParams(); // Get the 'lang' parameter from the URL
    const { t } = useTranslation(); // Get translation hook
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState('');

    // Newsletter subscription handler
    const handleSubscribe = async () => {
        if (!email) {
            setModalMessage(t('footer_email_validation', 'Bitte geben Sie eine gültige E-Mail-Adresse ein.'));
            setShowModal(true);
            return;
        }

        setLoading(true);
        try {
            const response = await fetch(
                `https://find-together-api.sslbeta.de/api/Newsletter/subscribe-public?email=${encodeURIComponent(email)}`,
                { method: 'POST', headers: { 'Content-Type': 'application/json' } }
            );
            const data = await response.json();
            if (response.ok) {
                setModalMessage(t('footer_subscription_success', 'Abonnement erfolgreich!'));
                setEmail(''); // Clear email on success
            } else {
                setModalMessage(data.message || t('footer_subscription_failed', 'Abonnement fehlgeschlagen.'));
            }
        } catch (error) {
            setModalMessage(t('footer_error_occurred', 'Ein Fehler ist aufgetreten.'));
        } finally {
            setLoading(false);
            setShowModal(true);
        }
    };

    // Modal close handler
    const handleClose = () => {
        setShowModal(false);
    };

    return (
        <div className='footer-section'>
            <div className='container home-container mb-5 secondary-background-color'>
                <Row className='pt-5'>
                    <Col sm={12} md={3} className='hilfe'>
                        <a href={`/${lang}/legal/agb`}>{t('footer_agb', 'AGB')}</a>
                        <a href={`/${lang}/legal/impressum`}>{t('footer_impressum', 'Impressum')}</a>
                        <a href={`/${lang}/legal/datenschutz`}>{t('footer_privacy', 'Datenschutz')}</a>
                    </Col>
                    <Col sm={12} md={3} className='bereiche'>
                        <a href="mailto:support@findtogether.de?subject=Kontakt">{t('footer_contact', 'Kontakt')}</a>
                        <a href={`/${lang}/about`}>{t('footer_about', 'Über uns')}</a>
                        <a href={`/${lang}/faq`}>{t('footer_faq', 'FAQ')}</a>
                        <a href={`/${lang}/Anmeldung`}>{t('footer_login', 'Login')}</a>
                    </Col>
                    <Col sm={12} md={3} className='uns'>
                        <a href="https://www.facebook.com/profile.php?id=61564938482464" target="_blank" rel="noopener noreferrer">Facebook</a>
                        <a href="https://www.instagram.com/findtogether_app/" target="_blank" rel="noopener noreferrer">Instagram</a>
                        <a href="https://www.tiktok.com/@find_together" target="_blank" rel="noopener noreferrer">Tiktok</a>
                    </Col>
                    <Col sm={12} md={3} className="newsletter-container">
                        <img src={logo} alt="Find Together Logo" className='footer-logo' />
                        <p className='fw-bold'>{t('footer_newsletter_title', 'Newsletter abonnieren')}</p>
                        <div className="newsletter-input-container">
                            <input
                                type="email"
                                placeholder={t('footer_email_placeholder', 'E-Mail-Adresse')}
                                className="newsletter-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <button type="button" onClick={handleSubscribe} className="newsletter-button">
                                {loading ? <span className="bubble-spinner"></span> : t('footer_subscribe_button', 'Los')}
                            </button>
                        </div>
                    </Col>
                </Row>

                <Modal show={showModal} onHide={handleClose} centered>
                    <Modal.Body
                        className='d-flex justify-content-between'
                        style={{ backgroundColor: modalMessage === t('footer_error_occurred', 'Ein Fehler ist aufgetreten.') ? '#ffcccc' : '#e7f6ec' }}
                    >
                        {modalMessage}
                        <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    );
};

export default Footer;
